export enum Namespaces {
    aliyun = "aliyun",
}
